export const useWebView = () => {
    /**
     * Determine if the website was loaded from within a WebView.
     * In this case, we can interact with the bridge provided by React Native.
     *
     * @returns {boolean}
     */
    function runningInWebView() {
        return !!getWebViewBridge();
    }

    /**
     * Retrieve the bridge provided to the WebView.
     * The bridge exposes various methods, which can be used to
     * interact with React Native.
     *
     * @returns {EventTarget|undefined}
     */
    function getWebViewBridge() {
        return window.fixform;
    }

    /**
     * Get the current version and build number of the
     * native app.
     *
     * @returns {object}
     */
    function getInfo() {
        return getWebViewBridge().getAppInfo();
    }

    /**
     * Opens the settings (e.g.: when user previously denied push notification permissions).
     */
    function openSettings() {
        getWebViewBridge().openSettings();
    }

    /**
     * Request a dispatched event with the messaging details.
     */
    function requestMessagingDetails() {
        getWebViewBridge().requestMessagingDetails();
    }

    /**
     * Open the native iOS or Android share dialog.
     *
     * @param {string} url
     * @param {string} description
     */
    function invokeShareDialog(url, description) {
        getWebViewBridge().invokeShareDialog({
            url,
            description,
        });
    }

    /**
     * Open the given URL with the default browser.
     *
     * @param {string} url
     */
    function openURL(url) {
        getWebViewBridge().openURL(url);
    }

    return {
        runningInWebView,
        getWebViewBridge,
        openSettings,
        requestMessagingDetails,
        invokeShareDialog,
        getInfo,
        openURL,
    };
};
